import React, { Component } from "react"
import { Link } from "react-router-dom"
import config from "react-global-configuration"
import * as path from "../../constants/Paths"
import * as tracking from "../../helpers/tracking"
import * as cookieNames from "../../constants/Cookies"
import ParkingProductHighlightElement from "../ParkingList/parkingProductHighlightElement"
import ParkingServiceBanner from "../ParkingList/parkingServiceBanner"
import * as cookieHelper from "../../../helpers/cookie"

class ParkingExtraServicesPodiumList extends Component {
  constructor(props) {
    super(props)
    this.impressionsRendered = false
  }

  state = {
    isTracked: false,
    animateButton: true,
  }

  componentDidUpdate() {
    if (this.props.track) {
      if (this.props.bookingResult) {
        if (!this.state.isTracked) {
          if (this.props.cookies.get(cookieNames.ACCESS_TOKEN)) {
            if (!this.props.loadingContactDetails && this.props.userAccountDetails) {
              tracking.trackPageView(
                this.props,
                "parking booking",
                "/virtual/(|en/|sv/)parkering/search/extra-services" + `${this.props.useNewDesign ? "?newDesign=true" : ""}`,
              )
              this.trackSelectedParking()
              tracking.trackParkingInteraction(this.props, "add_to_cart")
              this.setState({ isTracked: true })
            }
          } else {
            tracking.trackPageView(
              this.props,
              "parking booking",
              "/virtual/(|en/|sv/)parkering/search/extra-services" + `${this.props.useNewDesign ? "?newDesign=true" : ""}`,
            )
            this.trackSelectedParking()
            tracking.trackParkingInteraction(this.props, "add_to_cart")
            this.setState({ isTracked: true })
          }
        }
      }
    }
  }

  trackSelectedParking = () => {
    const { booking, product, parking } = this.props.bookingResult
    const userId = cookieHelper.getUserId(this.props)
    const data = {
      event: "track-event",
      eventCategory: this.props.flightId ? "travel planner" : "parking flow",
      eventAction: "options - select car park",
      eventLabel: product.name,
      eventValue: parking.amount,
      eventNoninteraction: true,
      userParkingArrivalDate: booking.arrivalDate,
      userParkingDepartureDate: booking.departureDate,
      pageBusinessunit: "parking",
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (this.props.flightId) data.travelplannerFlightId = this.props.flightId
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }

  handleBackTracking = () => {
    tracking.trackParkingFlowClick("go back", "step 3", this.props)
  }

  render() {
    if (!this.props.bookingResult) return null

    const { booking, product, carPark, activeBookingExtraProducts } = this.props.bookingResult
    const { content } = this.props

    const listTextKeys = config.get("textKeys.extraServices.list") || {}
    const elementTextKeys = config.get("textKeys.extraServices.element") || {}
    const selectorModalTextKeys = config.get("textKeys.extraServices.selectorModal") || {}
    if (!this.props.bookingExtras) return null

    let extrasToShowFromConfig = this.props.bookingExtrasConfiguration.extraServices.filter((s) => !s.showInCheckout)
    let extrasToShowFromProduct = this.props.bookingExtras.filter(
      (be) => be.active && be.isAvailable && extrasToShowFromConfig.find((c) => c.id === be.id),
    )

    if (extrasToShowFromProduct.length !== 0) {
      return extrasToShowFromProduct.map((extraProduct, extraProductIndex) => {
        const carWash = this.props.bookingExtrasConfiguration.extraServices.find((e) => e.id === extraProduct.id)
        const carWashFeatures = this.props.bookingExtrasConfiguration.Options[carWash.extraProductCode]
        const categoryNames = carWash && carWash.categories.map((c) => c.type)
        const selectedCategoryName = this.state.selectedCategoryName || carWash.categories[0].type
        const currentCategory = carWash.categories.find((c) => c.type === selectedCategoryName)
        const offersForSelectedCategory = extraProduct.offerLines.filter((o) => Object.values(currentCategory.offerLineIds).find((s) => s === o.id))
        const keysInConfigOrder = Object.values(currentCategory.offerLineIds).filter((o) => extraProduct.offerLines.find((s) => s.id === o))
        return (
          <React.Fragment key={extraProductIndex}>
            <section className="deck deck--white">
              <div className="w--wider">
                <div className="grid">
                  {keysInConfigOrder.map((key, index) => {
                    const offer = offersForSelectedCategory.find((o) => o.id === key)
                    let image = extraProduct.dynamicFields.productImage
                    let description = offer.description
                    let ribbonText = ""

                    const contentProduct =
                      this.props.content &&
                      this.props.content.extraProducts &&
                      this.props.content.extraProducts.find((p) => p.productId === extraProduct.id)
                    const contentVariant = contentProduct && contentProduct.variants.find((v) => v.variantId === offer.id)

                    const isSelectedProduct = activeBookingExtraProducts.find(
                      (active) => active.product.id === extraProduct.id && active.variants.find((v) => v.productOffer.id === offer.id),
                    )

                    if (contentVariant) {
                      image = contentVariant.variantImageUrl !== "" && contentVariant.variantImageUrl

                      if (contentVariant.variantResume && contentVariant.variantResume !== "") description = contentVariant.variantResume
                      if (contentVariant.variantBannerText && contentVariant.variantBannerText !== "") ribbonText = contentVariant.variantBannerText
                      // if (contentVariant.variantImageUrl && contentVariant.variantImageUrl !== '')
                      //     image = contentVariant.variantImageUrl
                    }

                    if (index < 3) {
                      return (
                        <ParkingProductHighlightElement
                          isExtraService={true}
                          key={`ParkingProductHighlight-${index}`}
                          image={image}
                          name={offer.name}
                          description={description}
                          price={offer.totalPricePerUnit}
                          grid_classes="grid-item col--12 col-xs--4"
                          buttonText={selectorModalTextKeys.button || "Tilføj"}
                          buttonOnClick={() => this.props.extraServicesAcceptConditionsModalActivate(extraProduct, offer, contentVariant)}
                          noOriginalPrice={true}
                          modifier_class="parking-product-highlight--stagger"
                          modalButtonText={elementTextKeys.readMore || "Læs mere"}
                          modalButtonOnClick={() => this.props.extraServicesDetailsModalToggle(extraProduct, offer, contentVariant)}
                          product={extraProduct}
                          offer={offer}
                          animateButton={true}
                          isSelectedProduct={isSelectedProduct}
                          priceFormatter={this.props.priceFormatter}
                          ribbonText={ribbonText}
                          arrivalDate={this.props.arrivalDate}
                          arrivalTime={this.props.arrivalTime}
                          departureDate={this.props.departureDate}
                          departureTime={this.props.departureTime}
                          cookies={this.props.cookies}
                        />
                      )
                    }
                  })}
                </div>
                {offersForSelectedCategory.length < 4 ? (
                  ""
                ) : (
                  <div className="grid">
                    {keysInConfigOrder.map((key, index) => {
                      const offer = offersForSelectedCategory.find((o) => o.id === key)
                      const image = extraProduct.dynamicFields.productImage
                      let description = offer.description

                      const contentProduct =
                        this.props.content &&
                        this.props.content.extraProducts &&
                        this.props.content.extraProducts.find((p) => p.productId === extraProduct.id)
                      const contentVariant = contentProduct && contentProduct.variants.find((v) => v.variantId === offer.id)

                      const isSelectedProduct = activeBookingExtraProducts.find(
                        (active) => active.product.id === extraProduct.id && active.variants.find((v) => v.productOffer.id === offer.id),
                      )

                      if (contentVariant) {
                        if (contentVariant.variantResume && contentVariant.variantResume !== "") description = contentVariant.variantResume
                      }
                      if (index >= 3) {
                        return (
                          <ParkingServiceBanner
                            key={`ParkingServiceBanner-${index}`}
                            title={offer.name}
                            ribbon="Totalpakke"
                            price={offer.totalPricePerUnit}
                            body={description}
                            modifier_class="grid-item col--12"
                            modalButtonText={elementTextKeys.readMore || "Læs mere"}
                            modalButtonOnClick={() => this.props.extraServicesDetailsModalToggle(extraProduct, offer, contentVariant)}
                            buttonText={elementTextKeys.button || "Reservér"}
                            buttonOnClick={() => this.props.extraServicesAcceptConditionsModalActivate(extraProduct, offer, contentVariant)}
                            product={extraProduct}
                            offer={offer}
                            isSelectedProduct={isSelectedProduct}
                            priceFormatter={this.props.priceFormatter}
                          />
                        )
                      }
                    })}
                  </div>
                )}
              </div>
            </section>
            <section className="deck deck--white deck--padding-bottom">
              <div className="w--wider">
                <div className="parking-product-highlight__disclaimer">
                  <span dangerouslySetInnerHTML={{ __html: elementTextKeys.noticeHtml }} />
                </div>
              </div>
            </section>
            <React.Fragment>
              <section className="deck deck--white deck--extra-padding-bottom deck--padding-top">
                <div className="w--wider">
                  <div className="action-buttons action-buttons--full">
                    <Link className="button button--medium button--general" to={`${path.CHECKOUT()}${this.props.location.search}`}>
                      <span className="text">{listTextKeys.continue || "Fortsæt til betaling"}</span>
                    </Link>
                    <Link className="link" to={`${path.SEARCH()}${this.props.location.search}`} onClick={() => this.handleBackTracking()}>
                      {listTextKeys.back || "Tilbage"}
                    </Link>
                  </div>
                </div>
              </section>
            </React.Fragment>
          </React.Fragment>
        )
      })
    }

    return null
  }
}
export default ParkingExtraServicesPodiumList
